<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <base-button style="font-size: 18px" @click="getBack()" class="btn-link">
          &lt; Back
        </base-button>
      </div>
      <div class="row" v-if="module == 'afes'">
        <div class="col-lg-8">
          <card class="card-eprf">
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  BASIC DETAILS
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  Full Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="fullname" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="padding-top: 50px; color: #A5A5A5" v-if="view == 'add'">
                  Password <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px; display: flex" v-if="view == 'add'">
                  <input v-if="showPassword1" type="text" v-model="password" :class="{ 'custom-input': true }" />
                  <input v-else type="password" v-model="password" @focus="short = true"
                    :class="{ 'custom-input': true }" />
                  <button class="custom-button" @click="toggleShow1">
                    <span class="icon is-small is-right">
                      <i class="fas" :class="{
          'fa-eye-slash': showPassword1,
          'fa-eye': !showPassword1,
        }"></i>
                    </span>
                  </button>
                </div>
                <div style="display: flex" v-if="view == 'add'">
                  <p style="
                      font-style: italic;
                      font-size: 12px;
                      color: lightgray;
                    ">
                    Minimum 8 characters
                  </p>
                  &nbsp;&nbsp;
                  <p v-if="password.length < 8 && short" style="font-size: 12px; color: #EC1B23">
                    Not enough characters
                  </p>
                </div>

                <p style="padding-top: 50px; color: #A5A5A5" v-if="view == 'add'">
                  Confirm Password <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px; display: flex" v-if="view == 'add'">
                  <input v-if="showPassword" type="text" v-model="confirmpassword" @focus="showPasswordMismatch = true"
                    :class="{ 'custom-input': true }" />
                  <input v-else type="password" v-model="confirmpassword" @focus="showPasswordMismatch = true"
                    :class="{ 'custom-input': true }" />
                  <button class="custom-button" @click="toggleShow">
                    <span class="icon is-small is-right">
                      <i class="fas" :class="{
          'fa-eye-slash': showPassword,
          'fa-eye': !showPassword,
        }"></i>
                    </span>
                  </button>
                </div>
                <div style="display: flex" v-if="view == 'add'">
                  <p style="
                      font-style: italic;
                      font-size: 12px;
                      color: lightgray;
                    ">
                    Minimum 8 characters
                  </p>
                  &nbsp;&nbsp;
                  <p v-if="showPasswordMismatch && confirmpassword !== password" style="font-size: 12px; color: #EC1B23">
                    Password does not match
                  </p>
                </div>

                <p style="padding-top: 50px; color: #A5A5A5">
                  Phone No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="phoneno" :class="{ 'custom-input': true }" :disabled="preview" />

                  <p v-if="isphoneno" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>
                <div v-if="positionid == 4">
                  <p style="padding-top: 50px; padding-bottom: 10px; color: #A5A5A5">
                    Digital Signature <span style="color: #EC1B23">*</span> <span
                      style="font-style: italic; font-size: 11px; color: #A5A5A5;">Please upload image with size 300x150
                      (2:1)</span>
                  </p>
                  
                  <div class="row">
                    <div class="col-lg-3">
                      <label for="image-upload">
                        <div
                          style="border-radius: 10px; display: flex; align-items: center; justify-content: center; border: 1px dashed #358CCB; width: 310px; height: 160px;">

                          <input accept="image/*" id="image-upload" type="file" ref="imageupload" name="..."
                            class="valid" aria-invalid="false" style="display: none" @change="onImagesChange" />

                          <div v-if="!image">
                            <i style="color: #A5A5A5; font-size: 40px; font-weight: 700"
                              class="tim-icons icon-camera-18"></i>

                          </div>
                          <div v-if="image">
                            <div class="image-container">
                              <img :src="image.url" class="digital-signature" />
                              <img src="@/assets/img/sample.png" class="sample-signature" />
                            </div>
                            <div style="position: absolute; right: -140%; top: 0">
                              <base-button class="btn-icon btn-cancel btn-round btn-xs" @click="removeImages(image.id)">
                                <i class="fa fa-times" aria-hidden="true"></i>
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div v-if="load" class="loading-bar">
                      <div class="loading-bar-progress" :style="{ width: loadingPercentage + '%' }"></div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  Email <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="email" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>
                <p style="color: #A5A5A5; font-size: 10px; margin-top: -1px">
                  {{ this.email_unique }}
                </p>

                <p style="padding-top: 50px; color: #A5A5A5">
                  User Type <span style="color: #EC1B23">*</span>
                </p>
                <el-select class="select-info tab select-width" placeholder="Select" v-model="selects.usertype"
                  style="width: 90%; border-bottom: 1px solid lightgray" :disabled="preview" filterable>
                  <el-option v-for="option in selects.usertypes" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>

                <p style="padding-top: 50px; color: #A5A5A5" v-if="selects.usertype == 2">
                  Service Location <span style="color: #EC1B23">*</span>
                </p>
                <el-select v-if="selects.usertype == 2" class="select-info tab select-width" placeholder="Select"
                  v-model="selects.servicelocation" style="width: 90%; border-bottom: 1px solid lightgray"
                  :disabled="preview" filterable>
                  <el-option v-for="option in selects.servicelocations" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>

                <p style="padding-top: 80px; color: #A5A5A5">
                  Staff ID <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="staffID" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="padding-top: 80px; color: #A5A5A5">Remarks (if any)</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="remarks" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="row scrollable-row" v-if="module == 'land' ||
          module == 'vessel' ||
          module == 'vendor' ||
          module == 'authority'
          ">
        <div class="col-lg-6 d-flex" v-if="module != 'authority'">
          <card class="card-eprf">
            <br />
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  BASIC DETAILS
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <p style="color: #A5A5A5">
                  Company Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyname" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Company Reg. No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyregno" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Company Address <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyaddress" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">Company Fax Number</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyfaxno" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Company Phone Number <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="companyphonenumber" :class="{ 'custom-input': true }"
                    :disabled="preview" />
                  <p v-if="iscompanyphonenumber" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>
              </div>
              <div class="col-lg-6">
                <p style="color: #A5A5A5" v-if="module == 'vendor'">
                  DOE License <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px" v-if="module == 'vendor'">
                  <input type="text" v-model="doelicense" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5" v-if="module == 'vendor'">
                  DOE Expired at <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px" v-if="module == 'vendor'">
                  <el-date-picker v-model="doeexpired" placeholder="Select" :disabled="preview"></el-date-picker>
                </div>

                <p style="color: #A5A5A5" v-if="module == 'vendor'">
                  Facility Type <span style="color: #EC1B23">*</span>
                </p>
                <el-select v-if="module == 'vendor'" class="select-info tab select-width" placeholder="Select"
                  v-model="facilitytype" style="width: 90%; border-bottom: 1px solid lightgray" filterable
                  :disabled="preview">
                  <el-option v-for="re in selects.facilitytypes" class="select-info" :value="re.value" :label="re.label"
                    :key="re.value"></el-option>
                </el-select>

                <p style="color: #A5A5A5" v-if="module == 'land' || module == 'vessel'">
                  Position <span style="color: #EC1B23">*</span>
                </p>
                <el-select v-if="module == 'land' || module == 'vessel'" class="select-info tab select-width"
                  placeholder="Select" v-model="position" style="width: 90%; border-bottom: 1px solid lightgray"
                  filterable :disabled="preview">
                  <el-option v-for="re in selects.positions" class="select-info" :value="re.value" :label="re.label"
                    :key="re.value"></el-option>
                </el-select>

                <p style="color: #A5A5A5" v-if="module == 'vendor'">
                  SW Codes <span style="color: #EC1B23">*</span>
                </p>
                <el-select v-if="module == 'vendor'" class="select-info tab select-width" placeholder="Select"
                  v-model="selects.sw" style="
                    width: 90%;
                    border-bottom: 1px solid lightgray;
                    color: pink !important;
                  " filterable multiple :disabled="preview">
                  <el-option v-for="re in selects.swes" class="select-info" :value="re.value" :label="re.label"
                    :key="re.value"></el-option>
                </el-select>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="module == 'authority'">
          <card class="card-eprf">
            <br />
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  BASIC DETAILS
                </p>
              </div>
            </div>
            <div class="row" style="height: 520px">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  Agency Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="agencyname" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Phone Number <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="phonenumber" :class="{ 'custom-input': true }" :disabled="preview" />
                  <p v-if="isphonenumber" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5">Fax Number</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="faxnumber" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="module == 'vendor'">
          <card class="card-eprf">
            <br />
            <div class="row" style="display: flex">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                TRANSPORTER DETAILS
              </p>
            </div>
            <div class="row">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  Transporter Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transportername" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  DOE No <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="doeno" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Transporter Address <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transporteraddress" :class="{ 'custom-input': true }"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Transporter Phone No. <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transporterphoneno" :class="{ 'custom-input': true }"
                    :disabled="preview" />
                  <p v-if="istransporterphoneno" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5">Transporter Fax</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transporterfax" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="module == 'vessel'" v-for="(item, index) in ships" :key="index">
          <card class="card-eprf">
            <br />
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  SHIP DETAILS
                </p>
              </div>
              <div class="col-lg-2 text-right">
                <base-button class="btn-icon btn-round btn-cancel" @click="removeship(index)"><i
                    class="tim-icons icon-simple-remove"></i>
                </base-button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  Ship Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.shipname" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Ship Type <span style="color: #EC1B23">*</span>
                </p>
                <el-select class="select-info tab select-width" placeholder="Select" v-model="item.shiptype"
                  style="width: 90%; border-bottom: 1px solid lightgray" :disabled="preview" filterable>
                  <el-option v-for="option in selects.shiptypes" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>

                <p style="color: #A5A5A5">
                  IMO Number <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.imonumber" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Gross Tonnage <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="number" v-model="item.grosstonnage" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Deadweight Tonnage <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="number" v-model="item.deadweighttonnage" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Operator Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.operatorname" :class="{ 'custom-input': true }"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Call Sign <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.callsign" :class="{ 'custom-input': true }" :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  Flag <span style="color: #EC1B23">*</span>
                </p>
                <el-select class="select-info tab select-width" placeholder="Select" v-model="item.flag"
                  style="width: 90%; border-bottom: 1px solid lightgray" filterable :disabled="preview">
                  <el-option v-for="option in selects.flags" class="select-info" :value="option.value"
                    :label="option.label" :key="option.value"></el-option>
                </el-select>
              </div>
            </div>
          </card>
        </div>
        <!-- add ships -->
        <div class="col-lg-3 d-flex" v-if="module == 'vessel'">
          <card class="card-eprf">
            <br />
            <div class="row">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                ADD SHIP
              </p>
            </div>
            <br />
            <br />
            <div class="row">
              <div class="col-lg text-center">
                <base-button class="btn-icon-eprf btn-link" @click="addship()" :disabled="preview"><img
                    src="@/assets/img/plus.png" width="230" />
                </base-button>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'authority'">
          <card class="card-eprf">
            <br />

            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              UPLOAD AUTHORITY SUPPORT DOCUMENT
            </p>
            <p class="newtitle">Choose File from Your Desktop</p>
            <!-- <p class="sub-title">
                Please upload any existing contract for recurring job request
              </p> -->
            <div class="fileinput">
              <label for="authority-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                      Upload
                    </label> -->
              <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="authority-upload" type="file" ref="authorityfile" name="..."
                class="valid" :multiple="true" aria-invalid="false" style="display: none" v-on:change="onInvoiceChange5"
                :disabled="preview" />
            </div>
            <div v-if="this.uploadload == false" style="
                height: 100%;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in allauthority" :key="index" class="row">
                <div class="col-lg-8">
                  <p style="padding-left: 15px; color: #A5A5A5" id="file-name">
                    {{ file.filename }}
                  </p>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                    @click="removeAuthorityFile(file.fileid)" :disabled="preview">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="view !== 'add' && module != 'authority'" style="height: 630px">
          <card class="card-eprf">
            <br />

            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              UPLOAD COMPANY SUPPORT DOCUMENT
            </p>
            <p class="newtitle">Choose File from Your Desktop</p>
            <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p>
            <div class="fileinput">
              <label for="invoice-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                      Upload
                    </label> -->
              <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="invoice-upload" type="file" ref="invoicefile" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onInvoiceChange"
                :disabled="preview" />
            </div>
            <div v-if="this.uploadload == false" style="
                height: 100%;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in allInvoice" :key="index" class="row">
                <div class="col-lg-8">
                  <p style="padding-left: 15px; color: #A5A5A5" id="file-name">
                    {{ file.filename }}
                  </p>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removecompanyfile(file.fileid)"
                    :disabled="preview">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'vendor'">
          <card class="card-eprf">
            <br />

            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              UPLOAD TRANSPORTER SUPPORT DOCUMENT
            </p>
            <p class="newtitle">Choose File from Your Desktop</p>
            <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p>
            <div class="fileinput">
              <label for="transporter-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                      Upload
                    </label> -->
              <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="transporter-upload" type="file" ref="transporterfile" name="..."
                class="valid" :multiple="true" aria-invalid="false" style="display: none" v-on:change="onInvoiceChange3"
                :disabled="preview" />
            </div>
            <div v-if="this.uploadload == false" style="
                height: 100%;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in alltransporter" :key="index" class="row">
                <div class="col-lg-8">
                  <p style="padding-left: 15px; color: #A5A5A5" id="file-name">
                    {{ file.filename }}
                  </p>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px"
                    @click="removeTransporterFile(file.fileid)" :disabled="preview">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'vendor'">
          <card class="card-eprf">
            <br />

            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              UPLOAD DOE SUPPORT DOCUMENT
            </p>
            <p class="newtitle">Choose File from Your Desktop</p>
            <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p>
            <div class="fileinput">
              <label for="doe-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                      Upload
                    </label> -->
              <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="doe-upload" type="file" ref="doefile" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onInvoiceChange4"
                :disabled="preview" />
            </div>
            <div v-if="this.uploadload == false" style="
                height: 100%;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in alldoe" :key="index" class="row">
                <div class="col-lg-8">
                  <p style="padding-left: 15px; color: #A5A5A5" id="file-name">
                    {{ file.filename }}
                  </p>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removeFile(file.fileid)"
                    :disabled="preview">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-if="view !== 'add' && module == 'vessel'">
          <card class="card-eprf">
            <br />

            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              UPLOAD SHIP SUPPORT DOCUMENT
            </p>
            <p class="newtitle">Choose File from Your Desktop</p>
            <p class="sub-title">
              Please upload any existing contract for recurring job request
            </p>
            <div class="fileinput">
              <label for="ship-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                      Upload
                    </label> -->
              <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="ship-upload" type="file" ref="shipfile" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onInvoiceChange2"
                :disabled="preview" />
            </div>
            <div v-if="this.uploadload == false" style="
                height: 100%;
                padding: 0px 20px 20px 0px;
                margin: 0px 30px 20px 0px;
              " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
              <div v-for="(file, index) in allships" :key="index" class="row">
                <div class="col-lg-8">
                  <p style="padding-left: 15px; color: #A5A5A5" id="file-name">
                    {{ file.filename }}
                  </p>
                </div>
                <div class="col-lg-4">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removeShipFile(file.fileid)"
                    :disabled="preview">
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>
        <!-- driver details -->
        <div v-if="module == 'vendor'" class="col-lg-3 d-flex" v-for="(item, index) in driverdetails" :key="index">
          <card class="card-eprf">
            <br />
            <div class="row">
              <div class="col-lg-10 text-left">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  DRIVER DETAILS - {{ index + 1 }}
                </p>
              </div>
              <div class="col-lg-2">
                <base-button class="btn-cancel btn-icon btn-round" @click="removedriver(index)"><i
                    class="tim-icons icon-simple-remove"></i></base-button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  Driver Name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.drivername" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  NRIC <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.nric" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>
              </div>
            </div>
          </card>
        </div>
        <!-- add driver -->
        <div class="col-lg-3 d-flex" v-if="module == 'vendor'">
          <card class="card-eprf">
            <br />
            <div class="row">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                ADD DRIVER
              </p>
            </div>
            <br />
            <br />
            <div class="row">
              <div class="col-lg text-center">
                <base-button class="btn-icon-eprf btn-link" @click="adddriver()" :disabled="preview"><img
                    src="@/assets/img/plus.png" width="230" />
                </base-button>
              </div>
            </div>
          </card>
        </div>
        <!-- truck details -->
        <div v-if="module == 'vendor'" class="col-lg-3 d-flex">
          <card class="card-eprf">
            <br />
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  TRUCK DETAILS
                </p>
              </div>
            </div>
            <div class="row" v-for="(item, index) in truckdetails" :key="index">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  Truck {{ index + 1 }} Registration Number
                  <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.registrationno" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>
              </div>
              <div class="col-lg-2 text-right" style="padding-top: 5%">
                <base-button class="btn-cancel btn-icon btn-round" @click="removetruck(index)"><i
                    class="tim-icons icon-simple-remove"></i></base-button>
              </div>
            </div>
          </card>
        </div>
        <!-- add truck -->
        <div class="col-lg-3 d-flex" v-if="module == 'vendor'">
          <card class="card-eprf">
            <br />
            <div class="row">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                ADD TRUCK
              </p>
            </div>
            <br />
            <br />
            <div class="row">
              <div class="col-lg text-center">
                <base-button class="btn-icon-eprf btn-link" @click="addtruck()" :disabled="preview"><img
                    src="@/assets/img/plus.png" width="230" />
                </base-button>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-3 d-flex" v-for="(item, index) in picdetails" :key="index" v-if="module != 'authority'">
          <card class="card-eprf">
            <br />
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  PIC DETAILS - {{ index + 1 }}
                </p>
              </div>
              <div class="col-lg-2 text-right">
                <base-button class="btn-cancel btn-icon btn-round" @click="removepic(index)"><i
                    class="tim-icons icon-simple-remove"></i></base-button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <p style="color: #A5A5A5">
                  User name <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.username" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  User Email <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.useremail" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5">
                  User Phone Number <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.userphonenumber" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                  <p v-if="item.userphonenumber.length <= 7" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5">User Fax Number</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="item.userfaxnumber" :class="{ 'custom-input': true }" min="0"
                    :disabled="preview" />
                </div>

                <p style="color: #A5A5A5" v-if="view == 'add' || item.flag == 'new'">
                  Password <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px; display: flex" v-if="view == 'add' || item.flag == 'new'">
                  <input v-if="showPassword1" type="text" v-model="item.password" :class="{ 'custom-input': true }" />
                  <input v-else type="password" v-model="item.password" @focus="short = true"
                    :class="{ 'custom-input': true }" />
                  <button class="custom-button" @click="toggleShow1">
                    <span class="icon is-small is-right">
                      <i class="fas" :class="{
          'fa-eye-slash': showPassword1,
          'fa-eye': !showPassword1,
        }"></i>
                    </span>
                  </button>
                </div>
                <div style="display: flex" v-if="view == 'add' || item.flag == 'new'">
                  <p style="
                      font-style: italic;
                      font-size: 12px;
                      color: lightgray;
                    ">
                    Minimum 8 characters
                  </p>
                  &nbsp;&nbsp;
                  <p v-if="item.password.length < 8 && short" style="font-size: 12px; color: #EC1B23">
                    Not enough characters
                  </p>
                </div>

                <p style="color: #A5A5A5" v-if="view == 'add' || item.flag == 'new'">
                  Confirm Password <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px; display: flex" v-if="view == 'add' || item.flag == 'new'">
                  <input v-if="showPassword" type="text" v-model="item.confirmpassword"
                    @focus="showPasswordMismatch = true" :class="{ 'custom-input': true }" />
                  <input v-else type="password" v-model="item.confirmpassword" @focus="showPasswordMismatch = true"
                    :class="{ 'custom-input': true }" />
                  <button class="custom-button" @click="toggleShow">
                    <span class="icon is-small is-right">
                      <i class="fas" :class="{
          'fa-eye-slash': showPassword,
          'fa-eye': !showPassword,
        }"></i>
                    </span>
                  </button>
                </div>
                <div style="display: flex" v-if="view == 'add' || item.flag == 'new'">
                  <p style="
                      font-style: italic;
                      font-size: 12px;
                      color: lightgray;
                    ">
                    Minimum 8 characters
                  </p>
                  &nbsp;&nbsp;
                  <p v-if="showPasswordMismatch &&
          item.confirmpassword !== item.password
          " style="font-size: 12px; color: #EC1B23">
                    Password does not match
                  </p>
                </div>
              </div>
            </div>
          </card>
        </div>

        <div class="col-lg-3 d-flex" v-if="module != 'authority'">
          <card class="card-eprf">
            <br />
            <div class="row">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                ADD PIC
              </p>
            </div>
            <br />
            <br />
            <div class="row">
              <div class="col-lg text-center">
                <base-button class="btn-icon-eprf btn-link" @click="addpic()" :disabled="preview"><img
                    src="@/assets/img/plus.png" width="230" />
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button type="danger" v-on:click="modals.cancelModal = true">Cancel</base-button>&nbsp;

          <base-button v-if="preview == false" :disabled="buttondisabled" type="primary" v-on:click="handleDone()">Done
          </base-button>
        </div>
      </div>
      <!-- <div class="row">
          <div class="col-lg text-right">
            <p style="color: #EC1B23">{{ errmsg }}</p>
          </div>
        </div> -->

      <modal :show.sync="modals.successModal" :preventClose="true">
        <div class="modal-header" style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #15cf79;
          ">
          <div class="col-lg"></div>
          <div class="col-lg-5">
            <div style="
                padding: 15px;
                background-color: transparent;
                border-radius: 100px;
                border: 10px solid white;
              ">
              <i style="color: white; font-size: 90px; font-weight: 900" class="tim-icons icon-check-2"></i>
            </div>
            <div>
              <p style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                ">
                Successful
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #707070;
            ">
            Congratulations!
          </p>

          <p style="color: #A5A5A5">Your account has been successfully created</p>

          <div style="display: flex">
            <p style="color: #A5A5A5">Please allow</p>
            &nbsp;
            <p style="font-weight: 600; color: #707070">3 working days</p>
            &nbsp;
            <p style="color: #A5A5A5">for your registration approval</p>
          </div>

          <p style="color: #A5A5A5; margin-top: 20px">
            Click 'Continue' to proceed to login page
          </p>
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="primary" v-on:click="getBack()">Continue</base-button>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.infoModal" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #15b0cf;
          ">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-info"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Info!
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">{{ message }}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center" style="margin-bottom: 30px">
            <base-button type="primary" v-on:click="modals.infoModal = false">Ok</base-button>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.successModal2" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #15cf79;
          ">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-check"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Successfull!
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">{{ message }}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center" style="margin-bottom: 30px">
            <base-button type="primary" v-on:click="modals.successModal2 = false">Continue</base-button>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.cancelModal" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #cf6a15;
          ">
          <div class="row">
            <div class="col-lg"></div>

            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-question"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Are you sure?
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">All changes will not be updated.</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-6 text-right" style="margin-bottom: 30px">
            <base-button type="danger" v-on:click="modals.cancelModal = false">Cancel</base-button>
          </div>
          <div class="col-lg-6 text-left" style="margin-bottom: 30px">
            <base-button type="primary" v-on:click="redirect()">Continue</base-button>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.failedModal" :preventClose="true">
        <div style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #EC1B23;
            text-align: center;
          ">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%;
                  border: 10px solid white;
                ">
                <i style="
                    padding: 15px;
                    color: white;
                    font-size: 130px;
                    font-weight: 900;
                  " class="fa fa-exclamation"></i>
              </div>
              <div>
                <p style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  ">
                  Error
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center">
            <p style="color: #A5A5A5">{{ message }}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <p style="color: #A5A5A5; margin-top: 20px">
              Click 'Retry' to go back.
            </p>

            <base-button type="danger" v-on:click="getBack()">Exit</base-button>&nbsp;
            <base-button type="primary" v-on:click="closeFailedModal()">Retry</base-button>
          </div>
        </div>
      </modal>
      <!-- <modal :show.sync="modals.failedModal">
        <div
          
          style="
            margin: -24px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #EC1B23;
            text-align: center;
          "
        >
        <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 text-center">
              <div style="
                  text-align: center;
                  border-radius: 100%; border: 10px solid white;
                  
                  ">
                <i
                  style="padding: 15px; color: white; font-size: 130px; font-weight: 900"
                  class="fa fa-exclamation"
                ></i>
              </div>
              <div>
                <p
                  style="
                    color: white;
                    font-size: 17px;
                    text-align: center;
                    font-weight: 500;
                  "
                >
                  Failed!
                </p>
              </div>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
        <br />
        <div class="row">
        <div class="col-lg-12 text-center">
          <p
            style="
              font-size: 40px;
              font-weight: 500;
              color: #707070;
            "
          >
            Warning!
          </p>
  
          <p style="color: #A5A5A5">Please fill in all the details.</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
          <p style="color: #A5A5A5; margin-top: 20px">Click 'Retry' to go back.</p>
  
            <base-button type="danger" v-on:click="getBack()">Exit</base-button
            >&nbsp;
            <base-button type="primary" v-on:click="closeFailedModal()"
              >Retry</base-button
            >
          </div>
        </div>
      </modal> -->
    </div>
  </div>
</template>

<script>
import { Alert, DatePicker } from "element-ui";
import swal from "sweetalert2";

import { Select, Option } from "element-ui";
//   import { colors } from "../../../components/colors.js";
import { getStorage } from "src/util/storage";
import { Modal, Card } from "@/components";
import { debounce } from "src/util/debounce";
import moment from "moment";

export default {
  name: "AddUser",

  components: {
    Card,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
  },

  data() {
    return {
      loadingPercentage: 0,
      load: false,
      image: null,
      errmsg: "",
      positionid: 0,
      preview: "",
      position: "",
      role: "",
      module: "",
      view: "add",
      buttondisabled: false,
      email_unique: "",
      // colors: colors,
      showPassword: false,
      showPassword1: false,

      short: "",
      short1: "",
      showPasswordMismatch: "",

      // afes
      fullname: "",
      password: "",
      confirmpassword: "",
      isphoneno: "",
      phoneno: "",
      email: "",
      staffID: "",
      remarks: "",

      // land
      companyname: "",
      companyregno: "",
      companyaddress: "",
      companyfaxno: "",
      iscompanyphonenumber: false,
      companyphonenumber: "",
      allInvoice: [],
      allships: [],
      alltransporter: [],
      alldoe: [],
      allauthority: [],
      picdetails: [
        {
          username: "",
          useremail: "",
          userphonenumber: "",
          userfaxnumber: "",
          password: "",
          confirmpassword: "",
        },
      ],

      // vessel
      ships: [
        {
          shipname: "",
          shiptype: "",
          imonumber: "",
          grosstonnage: "",
          deadweighttonnage: "",
          operatorname: "",
          callsign: "",
          flag: "",
        },
      ],

      // vendor
      transportername: "",
      doeno: "",
      transporteraddress: "",
      transporterphoneno: "",
      istransporterphoneno: false,
      transporterfax: "",
      driverdetails: [
        {
          drivername: "",
          nric: "",
        },
      ],
      truckdetails: [
        {
          id: "",
          registrationno: "",
        },
      ],
      doelicense: "",
      doeexpired: "",
      facilitytype: "",

      // authority
      agencyname: "",
      isphonenumber: false,
      phonenumber: "",
      faxnumber: "",

      modals: {
        successModal: false,
        successModal2: false,
        failedModal: false,
        failedModal2: false,

        cancelModal: false,

        infoModal: false,
        warningModal: false,
      },
      message: "",
      selects: {
        usertype: "",
        usertypes: [
          { value: 1, label: "AFES - Admin Main" },
          { value: 2, label: "AFES - Admin PIC" },
          { value: 3, label: "AFES - Operation" },
          { value: 4, label: "AFES - Management" },
          { value: 5, label: "Customer - Land Generator" },
          { value: 6, label: "Customer - Vessel Generator" },
          { value: 7, label: "Vendor" },
          { value: 8, label: "Authorities" },
        ],
        servicelocation: "",
        servicelocations: [],
        shiptypes: [],
        flags: [],
        facilitytypes: [],
        positions: [],
        sw: [],
        swes: [],
      },
      uploadload: false,
    };
  },
  methods: {
    removeImages(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/profile/digital-signature")
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                swal({
                  title: `Success!`,
                  text: 'File successfully deleted.',
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-primary btn-fill",
                  type: "success",
                });
                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
                // this.getDetail();
              }
            });
        }
      });
    },
    onImagesChange(e) {
      console.log("tengah tekan sini ha");
      this.load = true;
      this.loadingPercentage = 0;

      const input = e.target;
      const file = input.files[0];

      if (!file) {
        this.load = false;
        return;
      }

      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const aspectRatio = img.width / img.height;
        URL.revokeObjectURL(objectUrl); // Free up memory

        if ((img.width <= 300 && img.height <= 150) || (img.width / img.height === 2)) {
          const formData = new FormData();
          formData.append("image", file);

          const config = {
            headers: {
              Authorization: `Bearer ${getStorage("token")}`,
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              this.loadingPercentage = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            },
          };

          this.$http
            .post(":10001/api/v1/profile/digital-signature", formData, config)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log("response", response);
                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);

                this.load = false;
              }
            })
            .catch(() => {
              this.load = false;
            });
        } else {
          this.load = false;
          swal({
            title: `Failed!`,
            text: 'Please upload image with size 300x150 (2:1).',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-primary btn-fill",
            type: "error",
          });
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl); // Free up memory
        this.load = false;
        alert("Failed to load the image.");
      };

      img.src = objectUrl;
    }
    ,
    // onImagesChange(e) {
    //   this.load = true;

    //   const input = e.target;
    //   const formData = new FormData();
    //   formData.append("image", input.files[0]);

    //   this.$http
    //     .post(
    //       ":10001/api/v1/profile/digital-signature",
    //       formData,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${getStorage("token")}`,
    //           "Content-Type": "multipart/form-data",
    //         },
    //       }
    //     )
    //     .then((res) => {
    //       if (!res.error) {
    //         let response = res.message;
    //         this.image = { url: e.target.result, id: 1 };

    //         console.log("response", response);

    //         this.load = false;
    //       }
    //     });
    // },
    removeship(index) {
      this.ships.splice(index, 1);
    },
    closeModal() {
      this.modals.successModal2 = false;
      this.$router.push("/Users");
    },
    removetruck(index) {
      console.log(index);
      this.truckdetails.splice(index, 1);
    },
    removepic(index) {
      console.log(index);
      this.picdetails.splice(index, 1);
    },
    removedriver(index) {
      console.log(index);
      this.driverdetails.splice(index, 1);
    },
    redirect() {
      this.modals.successModal2 = false;
      this.$router.push("/Users");
    },
    getSW() {
      this.selects.swes = [];

      this.$http.get(":10001/api/v1/setting/wastes").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].code,
              value: response[i].waste_type_id,
            };
            this.selects.swes.push(obj);
          }
        }
      });
    },
    getFlag() {
      this.selects.flags = [];

      this.$http.get(":10001/api/v1/setting/flags").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].country_name,
              value: response[i].flag_id,
            };
            this.selects.flags.push(obj);
          }
        }
      });
    },
    getShipType() {
      this.selects.shiptypes = [];

      this.$http.get(":10001/api/v1/setting/ship_types").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].ship_type_name,
              value: response[i].ship_type_id,
            };
            this.selects.shiptypes.push(obj);
          }
        }
      });
    },
    getFacilityType() {
      this.selects.facilitytypes = [];
      this.$http.get(":10001/api/v1/setting/facilities").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var g = 0; g < response.length; g++) {
            let obj = {
              label: response[g].facility_type_name,
              value: response[g].facility_type_id,
            };
            this.selects.facilitytypes.push(obj);
          }
          console.log(this.selects.facilitytypes);
        }
      });
    },
    removeAuthorityFile(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/authority_support_document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal2 = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.failedModal2 = true;
              }
            });
        }
      });
    },
    removeTransporterFile(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/transporter_support_document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal2 = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.failedModal2 = true;
              }
            });
        }
      });
    },
    removeShipFile(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/ship_support_document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal2 = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.failedModal2 = true;
              }
            });
        }
      });
    },

    removecompanyfile(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/user-management/" +
              this.module +
              "/" +
              this.view +
              "/company_support_document/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal2 = true;

                setTimeout(() => {
                  this.getUserDetail(this.view, this.module);
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.failedModal2 = true;
              }
            });
        }
      });
    },
    onInvoiceChange() {
      let data = this.$refs.invoicefile.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      // if (this.module == "land") {
      let url =
        ":10001/api/v1/user-management/" +
        this.module +
        "/" +
        this.view +
        "/company_support_document";
      // }
      this.$http
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal2 = true;
            this.getUserDetail(this.view, this.module);

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
    },
    onInvoiceChange2() {
      let data = this.$refs.shipfile.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      // if (this.module == "land") {
      let url =
        ":10001/api/v1/user-management/" +
        this.module +
        "/" +
        this.view +
        "/ship_support_document";
      // }
      this.$http
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal2 = true;
            this.getUserDetail(this.view, this.module);

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
    },
    onInvoiceChange3() {
      let data = this.$refs.transporterfile.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      // if (this.module == "land") {
      let url =
        ":10001/api/v1/user-management/" +
        this.module +
        "/" +
        this.view +
        "/transporter_support_document";
      // }
      this.$http
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal2 = true;
            this.getUserDetail(this.view, this.module);

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
    },
    onInvoiceChange4() {
      let data = this.$refs.doefile.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      // if (this.module == "land") {
      let url =
        ":10001/api/v1/user-management/" +
        this.module +
        "/" +
        this.view +
        "/doe_support_document";
      // }
      this.$http
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal2 = true;
            this.getUserDetail(this.view, this.module);

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
    },
    onInvoiceChange5() {
      let data = this.$refs.authorityfile.files[0];

      const formData = new FormData();
      formData.append("document", data);

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      // if (this.module == "land") {
      let url =
        ":10001/api/v1/user-management/" +
        this.module +
        "/" +
        this.view +
        "/authority_support_document";
      // }
      this.$http
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal2 = true;
            this.getUserDetail(this.view, this.module);

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
    },
    addpic() {
      this.picdetails.push({
        userid: 0,
        username: "",
        useremail: "",
        userphonenumber: "",
        userfaxnumber: "",
        password: "",
        confirmpassword: "",
        flag: "new",
      });
    },
    addship() {
      this.ships.push({
        shipname: "",
        shiptype: "",
        imonumber: "",
        grosstonnage: "",
        deadweighttonnage: "",
        operatorname: "",
        callsign: "",
        flag: "",
      });
    },
    adddriver() {
      this.driverdetails.push({
        drivername: "",
        nric: "",
      });
    },
    addtruck() {
      this.truckdetails.push({
        registrationno: "",
      });
    },
    getServiceLocation() {
      this.selects.servicelocations = [];

      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].ServiceLocationId,
              label: response[i].Location,
            };

            this.selects.servicelocations.push(obj);
          }
          console.log(this.selects.servicelocations);
        }
      });
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },

    getBack() {
      this.$router.push("/Users");
    },

    // saveDraft() {
    //   console.log("save draft");
    // },

    getRoles() {
      this.selects.usertypes = [];

      this.$http.get(":10001/api/v1/setting/roles").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log("data here", response);

          for (var i = 0; i < response[0].Position.length; i++) {
            let obj = {
              label: response[0].Position[i].position_name,
              value: response[0].Position[i].position_id,
            };

            this.selects.usertypes.push(obj);
          }

          // this.selects.usertype = this.selects.usertypes[0].label;
        }
      });
    },

    successModal() {
      this.modals.successModal = true;
    },
    failedModal() {
      this.modals.failedModal = true;
    },
    closeFailedModal() {
      this.modals.failedModal = false;
    },

    handleDone() {
      let flag = "notcheck";
      let obj = {};

      if (this.module == "afes") {
        // check compulsary data
        if (
          this.fullname != "" &&
          this.email != "" &&
          this.phoneno != "" &&
          this.selects.usertype != "" &&
          this.staffID != ""
        ) {
          obj = {
            user_name: this.fullname,
            user_email: this.email,
            password: this.password,
            confirm_password: this.confirmpassword,
            user_phone_number: this.phoneno,
            position_id: this.selects.usertype,
            role_id: 1,
            employee_id: this.staffID,
            remarks: this.remarks,
            service_location_id:
              this.selects.servicelocation == ""
                ? null
                : this.selects.servicelocation,
          };

          flag = "checked";
        } else {
          this.message = "Please fill all the required column";
          this.modals.infoModal = true;
          flag = "notcheck";
        }
      }

      if (this.module == "land") {
        // check compulsary data
        for (var i = 0; i < this.picdetails.length; i++) {
          if (this.view == "add") {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != "" &&
              this.picdetails[i].password != "" &&
              this.picdetails[i].confirmpassword != "" &&
              this.companyname != "" &&
              this.companyregno != "" &&
              this.companyaddress != "" &&
              this.companyphonenumber != "" &&
              this.position != ""
            ) {
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          } else {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != "" &&
              this.companyname != "" &&
              this.companyregno != "" &&
              this.companyaddress != "" &&
              this.companyphonenumber != "" &&
              this.position != ""
            ) {
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          }
        }

        // get pic details
        let picdetails = [];
        console.log(this.picdetails[0]);
        for (var i = 0; i < this.picdetails.length; i++) {
          if (
            (this.picdetails[i].username != "") &
            (this.picdetails[i].useremail != "")
          ) {
            let pic = {
              user_id: this.picdetails[i].userid,
              user_name: this.picdetails[i].username,
              user_email: this.picdetails[i].useremail,
              user_phone_number: this.picdetails[i].userphonenumber,
              user_fax_number: this.picdetails[i].userfaxnumber,
              password: this.picdetails[i].password,
              confirm_password: this.picdetails[i].confirmpassword,
            };
            picdetails.push(pic);
          }
        }
        obj = {
          pic: picdetails,
          position_id: this.position,
          role_id: 2,
          company_name: this.companyname,
          company_address: this.companyaddress,
          company_reg_num: this.companyregno,
          company_phone_number: this.companyphonenumber,
          company_fax_number: this.companyfaxno,
          documents: [], // id gets from upload documents,
        };
      }

      if (this.module == "vessel") {
        // check compulsary data
        for (var i = 0; i < this.picdetails.length; i++) {
          if (this.view == "add") {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != "" &&
              this.picdetails[i].password != "" &&
              this.picdetails[i].confirmpassword != "" &&
              this.companyname != "" &&
              this.companyregno != "" &&
              this.companyaddress != "" &&
              this.companyphonenumber != "" &&
              this.position != ""
            ) {
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          } else {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != "" &&
              this.companyname != "" &&
              this.companyregno != "" &&
              this.companyaddress != "" &&
              this.companyphonenumber != "" &&
              this.position != ""
            ) {
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          }
        }

        // check ship
        let shipss = [];
        for (var i = 0; i < this.ships.length; i++) {
          if (
            this.ships[i].shipname != "" &&
            this.ships[i].shiptype != "" &&
            this.ships[i].imonumber != "" &&
            this.ships[i].grosstonnage != "" &&
            this.ships[i].deadweighttonnage != "" &&
            this.ships[i].operatorname != "" &&
            this.ships[i].callsign != "" &&
            this.ships[i].flag != ""
          ) {
            let oss = {
              ship_name: this.ships[i].shipname,
              imo_number: this.ships[i].imonumber,
              ship_type_id: this.ships[i].shiptype,
              gross_tonnage: parseInt(this.ships[i].grosstonnage),
              deadweight_tonnage: parseInt(this.ships[i].deadweighttonnage),
              operator_name: this.ships[i].operatorname,
              call_sign: this.ships[i].callsign,
              flag_id: this.ships[i].flag,
              ship_documents: [],
            };
            shipss.push(oss);
            flag = "checked";
          } else {
            flag = "notcheck";
          }
        }

        let picdetails = [];
        for (var i = 0; i < this.picdetails.length; i++) {
          if (
            (this.picdetails[i].username != "") &
            (this.picdetails[i].useremail != "")
          ) {
            let pic = {
              user_id: this.picdetails[i].userid,
              user_name: this.picdetails[i].username,
              user_email: this.picdetails[i].useremail,
              user_phone_number: this.picdetails[i].userphonenumber,
              user_fax_number: this.picdetails[i].userfaxnumber,
              password: this.picdetails[i].password,
              confirm_password: this.picdetails[i].confirmpassword,
            };
            picdetails.push(pic);
          }
        }
        obj = {
          role_id: 3,
          position_id: this.position,
          operation_type_id: 1,
          company_name: this.companyname,
          company_address: this.companyaddress,
          company_reg_num: this.companyregno,
          company_phone_number: this.companyphonenumber,
          company_fax_number: this.companyfaxno,
          documents: [],
          pic: picdetails,
          ship: shipss,
        };
      }

      if (this.module == "vendor") {
        let picdetails = [];
        for (var i = 0; i < this.picdetails.length; i++) {
          if (this.view == "add") {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != "" &&
              this.picdetails[i].password != "" &&
              this.picdetails[i].confirmpassword != ""
            ) {
              let pic = {
                user_id: this.picdetails[i].userid,
                user_name: this.picdetails[i].username,
                user_email: this.picdetails[i].useremail,
                user_phone_number: this.picdetails[i].userphonenumber,
                user_fax_number: this.picdetails[i].userfaxnumber,
                password: this.picdetails[i].password,
                confirm_password: this.picdetails[i].confirmpassword,
              };
              picdetails.push(pic);
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          } else {
            if (
              this.picdetails[i].username != "" &&
              this.picdetails[i].useremail != "" &&
              this.picdetails[i].userphonenumber != ""
            ) {
              let pic = {
                user_id: this.picdetails[i].userid,
                user_name: this.picdetails[i].username,
                user_email: this.picdetails[i].useremail,
                user_phone_number: this.picdetails[i].userphonenumber,
                user_fax_number: this.picdetails[i].userfaxnumber,
                password: this.picdetails[i].password,
                confirm_password: this.picdetails[i].confirmpassword,
              };
              picdetails.push(pic);
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          }
        }

        let driverlist = [];
        for (var i = 0; i < this.driverdetails.length; i++) {
          if (
            this.driverdetails[i].drivername != "" &&
            this.driverdetails[i].nric != ""
          ) {
            let driver = {
              driver_name: this.driverdetails[i].drivername,
              driver_nric: this.driverdetails[i].nric,
            };
            driverlist.push(driver);
            flag = "checked";
          } else {
            flag = "notcheck";
          }
        }

        let vehiclelist = [];
        for (var i = 0; i < this.truckdetails.length; i++) {
          if (this.truckdetails[i].registrationno != "") {
            let vehicle = {
              registration_no: this.truckdetails[i].registrationno,
            };
            vehiclelist.push(vehicle);
            flag = "checked";
          } else {
            flag = "notcheck";
          }
        }
        obj = {
          pic: picdetails,
          transporter: {
            transporter_name: this.transportername,
            doe_no: this.doeno,
            transporter_address: this.transporteraddress,
            transporter_phone: this.transporterphoneno,
            transporter_fax: this.transporterfax,
            driver: driverlist,
            vehicle: vehiclelist,
            transporter_documents: [],
          },
          company_name: this.companyname,
          company_address: this.companyaddress,
          company_reg_num: this.companyregno,
          company_phone_number: this.companyphonenumber,
          company_fax_number: this.companyfaxno,
          doe_licence: this.doelicense,
          doe_expired_at:
            this.doeexpired == ""
              ? null
              : moment(this.doeexpired).format("YYYY-MM-DD"),
          documents: [], // id gets from upload documents,

          waste_code_id: this.selects.sw,
          facility_type_id: this.facilitytype,
          doe_documents: [],
        };
      }

      if (this.module == "authority") {
        let picdetails = [];
        for (var i = 0; i < this.picdetails.length; i++) {
          if (this.view == "add") {
            if (
              // this.picdetails[i].username != "" &&
              // this.picdetails[i].useremail != "" &&
              // this.picdetails[i].userphonenumber != "" &&
              // this.picdetails[i].password != "" &&
              // this.picdetails[i].confirmpassword != "" &&
              this.agencyname != "" &&
              this.phonenumber != ""
            ) {
              // let pic = {
              //   user_id: this.picdetails[i].userid,
              //   user_name: this.picdetails[i].username,
              //   user_email: this.picdetails[i].useremail,
              //   user_phone_number: this.picdetails[i].userphonenumber,
              //   user_fax_number: this.picdetails[i].userfaxnumber,
              //   password: this.picdetails[i].password,
              //   confirm_password: this.picdetails[i].confirmpassword,
              // };
              // picdetails.push(pic);
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          } else {
            if (
              // this.picdetails[i].username != "" &&
              // this.picdetails[i].useremail != "" &&
              // this.picdetails[i].userphonenumber != "" &&
              this.agencyname != "" &&
              this.phonenumber != ""
            ) {
              // let pic = {
              //   user_id: this.picdetails[i].userid,
              //   user_name: this.picdetails[i].username,
              //   user_email: this.picdetails[i].useremail,
              //   user_phone_number: this.picdetails[i].userphonenumber,
              //   user_fax_number: this.picdetails[i].userfaxnumber,
              //   password: this.picdetails[i].password,
              //   confirm_password: this.picdetails[i].confirmpassword,
              // };
              // picdetails.push(pic);
              flag = "checked";
            } else {
              flag = "notcheck";
            }
          }
        }
        obj = {
          // pic: picdetails,
          agency_name: this.agencyname,
          phone_number: this.phonenumber,
          fax_number: this.faxnumber,
          documents: [],
        };
      }

      console.log("datas", obj);
      if (flag == "checked") {
        // add new user
        if (this.view == "add") {
          this.$http
            .post(":10001/api/v1/user-management/" + this.module, obj)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.modals.successModal = true;
                this.message = response;
                // this.$router.push("/Users");
              } else {
                this.modals.failedModal = true;
              }
            })
            .catch((err) => {
              this.message = err.response.data.message;
              this.modals.failedModal = true;
              this.errmsg = err.response.data.message;
            });
        }

        // edit existing user
        if (this.view != "add") {
          // let userid = this.$route.params.actionflag;
          let userid = "";

          if (this.module == "afes") {
            userid = JSON.parse(
              atob(sessionStorage.getItem("token").split(".")[1])
            ).userid;
          }

          if (
            this.module == "vessel" ||
            this.module == "land" ||
            this.module == "vendor"
          ) {
            userid = JSON.parse(
              atob(sessionStorage.getItem("token").split(".")[1])
            ).company_id;
          }

          if (this.module == "authority") {
            userid = JSON.parse(
              atob(sessionStorage.getItem("token").split(".")[1])
            ).authority_id;
          }
          console.log(userid);

          this.$http
            .put(
              ":10001/api/v1/user-management/update/" +
              this.module +
              "/" +
              userid,
              obj
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal2 = true;
              }
            })
            .catch((err) => {
              this.message = err.response.data.message;
              this.modals.failedModal = true;
              this.errmsg = err.response.data.message;
            });
        }
      } else {
        this.message = "Please fill all the required column";
        this.modals.infoModal = true;
      }
    },
    getUserDetail(id, module) {
      let userid = "";
      if (this.module == "afes") {
        userid = JSON.parse(
          atob(sessionStorage.getItem("token").split(".")[1])
        ).userid;
      }
      //console.log(
      // JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
      //);
      if (
        this.module == "vessel" ||
        this.module == "land" ||
        this.module == "vendor"
      ) {
        console.log("awak land tau")
        userid = JSON.parse(
          atob(sessionStorage.getItem("token").split(".")[1])
        ).company_id;
        console.log(userid);
      }

      if (this.module == "authority") {
        userid = JSON.parse(
          atob(sessionStorage.getItem("token").split(".")[1])
        ).authority_id;
      }

      console.log(userid);
      this.$http
        // .get(":10001/api/v1/user-management/" + module + "/" + userid)
        .get(":10001/api/v1/profile")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            if (this.module == "afes") {
              this.fullname = response.user_name;
              this.email = response.user_email;
              this.phoneno = response.user_phone_number;
              this.selects.usertype = parseInt(response.position.position_id);
              this.staffID = response.employee_id;
              this.remarks = response.remarks;
              this.selects.servicelocation = response.service_location_id;

              this.image = response.signature == null ? null : {
                url: response.signature.url,
                id: response.signature.document_id,
              };

            }

            if (this.module == "land") {
              this.companyname = response.company.company_name;
              this.companyregno = response.company.company_reg_num;
              this.companyaddress = response.company.company_address;
              this.companyfaxno = response.company.fax_number;
              this.companyphonenumber = response.company.phone_number;
              this.position = response.position.position_id;

              this.allInvoice = [];
              if (response.company.company_document != null) {
                for (var i = 0; i < response.company.company_document.length; i++) {
                  let obj = {
                    filename: response.company.company_document[i].meta.filename,
                    fileid: response.company.company_document[i].company_document_id,
                  };
                  this.allInvoice.push(obj);
                }
              }
              this.picdetails = [];
              for (var i = 0; i < response.company.pic.length; i++) {
                let obj = {
                  userid: response.company.pic[i].user_id,
                  username: response.company.pic[i].user_name,
                  useremail: response.company.pic[i].user_email,
                  userphonenumber: response.company.pic[i].user_phone_number,
                  userfaxnumber: response.company.pic[i].user_fax_number,
                };
                this.picdetails.push(obj);
              }
            }

            if (this.module == "vessel") {
              this.position = response.position.position_id;

              this.companyname = response.company.company_name;
              this.companyregno = response.company.company_reg_num;
              this.companyaddress = response.company.company_address;
              this.companyfaxno = response.company.fax_number;
              this.companyphonenumber = response.company.phone_number;

              // for(var i=0; i<)
              this.ships = [];
              if (response.company.ship != null) {
                for (var i = 0; i < response.company.ship.length; i++) {
                  this.ships.push({
                    shipname: response.company.ship[i].ship_name,
                    shiptype: response.company.ship[i].ship_type.ship_type_id,
                    imonumber: response.company.ship[i].imo_number,
                    grosstonnage: response.company.ship[i].gross_tonnage,
                    deadweighttonnage: response.company.ship[i].deadweight_tonnage,
                    operatorname: response.company.ship[i].operator_name,
                    callsign: response.company.ship[i].call_sign,
                    flag: response.company.ship[i].flag.flag_id,
                  });
                }
              }

              // this.shipname = response.company.ship[0].ship_name;
              // this.shiptype = response.company.ship[0].ship_type.ship_type_id;
              // this.imonumber = response.company.ship[0].imo_number;
              // this.grosstonnage = response.company.ship[0].gross_tonnage;
              // this.deadweighttonnage = response.company.ship[0].deadweight_tonnage;
              // this.operatorname = response.company.ship[0].operator_name;
              // this.callsign = response.company.ship[0].call_sign;
              // this.flag = response.company.ship[0].flag.flag_id;

              this.allInvoice = [];
              if (response.company_documents != null) {
                for (var i = 0; i < response.company_documents.length; i++) {
                  let obj = {
                    filename: response.company_documents[i].meta.filename,
                    fileid: response.company_documents[i].company_document_id,
                  };
                  this.allInvoice.push(obj);
                }
              }

              this.allships = [];
              if (response.ship.ship_support_documents != null) {
                for (
                  var i = 0;
                  i < response.ship.ship_support_documents.length;
                  i++
                ) {
                  let obj = {
                    filename:
                      response.ship.ship_support_documents[i].meta.filename,
                    fileid:
                      response.ship.ship_support_documents[i].ship_document_id,
                  };
                  this.allships.push(obj);
                }
              }

              this.picdetails = [];
              for (var i = 0; i < response.company.pic.length; i++) {
                let obj = {
                  userid: response.company.pic[i].user_id,
                  username: response.company.pic[i].user_name,
                  useremail: response.company.pic[i].user_email,
                  userphonenumber: response.company.pic[i].user_phone_number,
                  userfaxnumber: response.company.pic[i].user_fax_number,
                };
                this.picdetails.push(obj);
              }
              // console.log(obj);
            }

            if (this.module == "vendor") {
              this.companyname = response.company.company_name;
              this.companyregno = response.company.company_reg_num;
              this.companyaddress = response.company.company_address;
              this.companyfaxno = response.company.fax_number;
              this.companyphonenumber = response.company.phone_number;
              this.doeexpired = response.company.doe_expired_at;

              this.transportername = response.company.transporter[0].transporter_name;
              this.doeno = response.company.transporter[0].doe_no;
              this.transporteraddress =
                response.company.transporter[0].transporter_address;
              this.transporterphoneno = response.company.transporter[0].transporter_phone;
              this.transporterfax = response.company.transporter[0].transporter_fax;

              this.doelicense = response.company.doe_licence;
              // this.doeexpired = response.
              this.facilitytype = response.company.facility_type;
              this.selects.sw = response.company.waste_handled[0];

              this.allInvoice = [];
              if (response.company.company_document != null) {
                for (var i = 0; i < response.company.company_document.length; i++) {
                  let obj = {
                    filename: response.company.company_document[i].meta.filename,
                    fileid: response.company.company_document[i].company_document_id,
                  };
                  this.allInvoice.push(obj);
                }
              }

              this.driverdetails = [];
              // if (response.transporter.driver != null) {
              //   for (
              //     var i = 0;
              //     i < response.transporter.driver.length;
              //     i++
              //   ) {
              //     let obj = {
              //       filename:
              //         response.transporter.driver[i].meta.filename,
              //       fileid:
              //       response.transporter.driver[i].driver_document_id,
              //     };
              //     this.allships.push(obj);
              //   }
              // }

              this.truckdetails = [];
              if (response.company.transporter[0].vehicle != null) {
                for (var i = 0; i < response.company.transporter[0].vehicle.length; i++) {
                  let obj = {
                    registrationno:
                      response.company.transporter[0].vehicle[i].vehicle_reg_num,
                    id: response.company.transporter[0].vehicle[i].vehicle_id,
                  };
                  this.truckdetails.push(obj);
                }
              }

              this.picdetails = [];
              for (var i = 0; i < response.company.pic.length; i++) {
                let obj = {
                  userid: response.company.pic[i].user_id,
                  username: response.company.pic[i].user_name,
                  useremail: response.company.pic[i].user_email,
                  userphonenumber: response.company.pic[i].user_phone_number,
                  userfaxnumber: response.company.pic[i].user_fax_number,
                };
                this.picdetails.push(obj);
              }
              //doe n support
              this.alltransporter = [];
              if (response.transporter.transporter_support_documents != null) {
                for (
                  var i = 0;
                  i < response.transporter.transporter_support_documents.length;
                  i++
                ) {
                  let obj = {
                    filename:
                      response.transporter.transporter_support_documents[i].meta
                        .filename,
                    fileid:
                      response.transporter.transporter_support_documents[i]
                        .transporter_document_id,
                  };
                  this.alltransporter.push(obj);
                }
              }

              this.alldoe = [];
              if (response.doe_support_documents != null) {
                for (
                  var i = 0;
                  i < response.doe_support_documents.length;
                  i++
                ) {
                  let obj = {
                    filename: response.doe_support_documents[i].meta.filename,
                    fileid: response.doe_support_documents[i].doe_document_id,
                  };
                  this.alldoe.push(obj);
                }
              }
            }

            if (this.module == "authority") {
              this.agencyname = response.agency.agency_name;
              this.phonenumber = response.agency.phone_number;
              this.faxnumber = response.agency.fax_number;

              this.allauthority = [];
              if (response.agency.support_document != null) {
                for (
                  var i = 0;
                  i < response.agency.support_document.length;
                  i++
                ) {
                  let obj = {
                    filename:
                      response.agency.support_document[i].meta.filename,
                    fileid:
                      response.agency.support_document[i]
                        .document_id,
                  };
                  this.allauthority.push(obj);
                }
              }
              this.picdetails = [];
              for (var i = 0; i < response.agency.pic.length; i++) {
                let obj = {
                  userid: response.agency.pic[i].user_id,
                  username: response.agency.pic[i].user_name,
                  useremail: response.agency.pic[i].user_email,
                  userphonenumber: response.agency.pic[i].user_phone_number,
                  userfaxnumber: response.agency.pic[i].user_fax_number,
                };
                this.picdetails.push(obj);
              }
            }
          }
        });
    },
  },
  created() {
    // console.log()

    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    let module = JSON.parse(
      atob(sessionStorage.getItem("token").split(".")[1])
    ).role_id;
    console.log('module apa', module);

    this.module =
      module == 1
        ? "afes"
        : module == 2
          ? "land"
          : module == 3
            ? "vessel"
            : module == 4
              ? "vendor"
              : "authority";
    this.view = "view";

    if (this.positionid == 2) {
      console.log("sinih");
      if (this.$route.params.viewflag == "preview") {
        this.preview = true;
      } else {
        this.preview = false;
      }
    } else {
      this.preview = false;
    }
    this.getRoles();
    this.getServiceLocation();
    this.getShipType();
    this.getFlag();
    this.getFacilityType();
    this.getSW();
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  watch: {
    transporterphoneno() {
      if (this.transporterphoneno.length <= 7) {
        this.istransporterphoneno = true;
      } else {
        this.istransporterphoneno = false;
      }
    },
    phonenumber() {
      if (this.phonenumber.length <= 7) {
        this.isphonenumber = true;
      } else {
        this.isphonenumber = false;
      }
    },
    companyphonenumber() {
      if (this.companyphonenumber.length <= 7) {
        this.iscompanyphonenumber = true;
      } else {
        this.iscompanyphonenumber = false;
      }
    },
    phoneno() {
      if (this.phoneno.length <= 7) {
        this.isphoneno = true;
      } else {
        this.isphoneno = false;
      }
    },
    "selects.sw"() {
      console.log(this.selects.sw);
    },
    email: debounce(function () {
      if (this.view == "add") {
        this.email_unique = "";

        let obj = {
          user_email: this.email,
        };

        this.$http
          .post(":10001/api/v1/helper/check-user-email", obj)
          .then((res) => {
            let response = res.message;

            if (!res.error) {
              this.email_unique = response;
              this.buttondisabled = false;
            } else if (res.error) {
              this.email_unique = response;
              this.buttondisabled = true;
            } else {
              this.email_unique = "";
              this.buttondisabled = false;
            }
          });

        this.email_unique = "";
      }
    }, 500),

    password() {
      if (this.password != this.confirmpassword && this.password.length < 8) {
        this.buttondisabled = true;
      }

      if (this.password == this.confirmpassword && this.password.length >= 8) {
        this.buttondisabled = false;
      }
    },

    confirmpassword() {
      if (
        this.password != this.confirmpassword &&
        this.confirmpassword.length < 8
      ) {
        this.message = "Password did not match";
        this.buttondisabled = true;
      }

      if (
        this.password == this.confirmpassword &&
        this.confirmpassword.length >= 8
      ) {
        this.message = "";
        this.buttondisabled = false;
      }
    },
    view() {
      // add
      // if (this.view == "add") {
      //   this.fullname = "";
      //   this.email = "";
      //   this.password = "";
      //   this.confirmpassword = "";
      //   this.phoneno = "";
      //   this.selects.usertype = "";
      //   this.staffID = "";
      //   this.remarks = "";
      //   this.selects.servicelocation = "";
      // }

      // edit
      if (this.view != "add") {
        this.getUserDetail(this.view, this.module);
      }
    },
    module() {
      if (this.module == "afes") {
        this.role = 1;
      }
      if (this.module == "land") {
        this.role = 2;
      }
      if (this.module == "vessel") {
        this.role = 3;
      }

      if (this.module == "vendor") {
        this.role = 4;
      }

      if (this.module == "authority") {
        this.role = 5;
      }
    },
    role() {
      this.$http.get(":10001/api/v1/setting/roles").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            if (this.role == response[i].role_id) {
              for (var j = 0; j < response[i].Position.length; j++) {
                let obj = {
                  label: response[i].Position[j].position_name,
                  value: response[i].Position[j].position_id,
                };
                this.selects.positions.push(obj);
              }
            }
          }
        }
      });
    },
  },
};
</script>
<style>
.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

.newtitle {
  color: #707070 !important;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-title {
  margin-top: -5px;
  color: #A5A5A5 !important;
}

.loading-bar {
  position: relative;
  width: 100%;
  height: 4px;
  background-color: #e0e0e0;
  margin-top: 10px;
}

.loading-bar-progress {
  position: absolute;
  height: 100%;
  background-color: #358CCB;
  transition: width 0.2s;
}

.image-container {
  position: relative;
  display: inline-block;
}

.digital-signature {
  max-width: 300px;
  max-height: 150px;
  object-fit: contain;
}

.sample-signature {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 300px;
  max-height: 150px;
  object-fit: contain;
}
</style>
